import { createBrowserHistory } from "history";
import React, { FunctionComponent, useState } from "react";
import { useIntl } from "react-intl";
import ButtonSmily from "@Components/atoms/ButtonSmily";
import WithLocale from "@Components/WithLocale";
import { ReactComponent as IconX } from "@Icons/16x16/x.svg";
import cheerzAppLogo from "@Images/logo-cheerz-app.png";
import getUrlAppStoreButton from "@Utils/appStoreUrl";
import stars from "./stars.png";
import "./style.scss";

const history = createBrowserHistory();

export const SmartAppBanner: FunctionComponent = () => {
  const intl = useIntl();
  const [dismissSmartAppBanner, setDismissSmartAppBanner] = useState<boolean>(
    sessionStorage.getItem("dismissSmartAppBanner") === "true" ? true : false
  );

  const handleDismiss = () => {
    sessionStorage.setItem("dismissSmartAppBanner", "true");
    setDismissSmartAppBanner(true);
  };

  const handleClickAppStore = () => {
    window.location.href = getUrlAppStoreButton();
  };

  return dismissSmartAppBanner ? null : (
    <div className="SmartAppBanner">
      <div className="SmartAppBanner-description">
        <IconX height="12" onClick={handleDismiss} width="12" />
        <img alt="Cheerz" className="SmartAppBanner-logo" src={cheerzAppLogo} />
        <div>
          <div className="SmartAppBanner-title">Cheerz app</div>
          <img alt="Stars" className="SmartAppBanner-stars" src={stars} />
        </div>
      </div>
      <ButtonSmily onClick={handleClickAppStore} size="s" type="primary">
        {intl.formatMessage({ id: "cheerz_SmartAppBanner_install" })}
      </ButtonSmily>
    </div>
  );
};

const SmartAppBannerContainer: FunctionComponent = () => {
  return (
    <WithLocale history={history}>
      <SmartAppBanner />
    </WithLocale>
  );
};

export default SmartAppBannerContainer;
